import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ExternalLink, AlertTriangle } from 'lucide-react';
import { Navbar } from '../components/layout/Navbar';
import { Button } from '../components/ui/Button';
export function HelpGoogleSheetsPage() {
  return <div className="min-h-screen bg-gray-50" dir="rtl" data-id="element-2062">
      <Navbar data-id="element-2063" />

      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-2064">
        <Link to="/configure" className="inline-flex items-center text-gray-600 hover:text-gray-900 mb-6" data-id="element-2065">
          <ArrowRight className="ml-2 w-4 h-4" data-id="element-2066" />
          رجوع إلى الإعدادات
        </Link>

        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-2067">
          <div className="p-8 border-b border-gray-100 bg-gradient-to-r from-blue-50 to-indigo-50" data-id="element-2068">
            <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-2069">
              كيفية ربط Google Sheets
            </h1>
            <p className="text-gray-600" data-id="element-2070">
              اتبع الخطوات التالية للحصول على Client ID و Client Secret من
              Google Cloud Console
            </p>
          </div>

          <div className="p-8 space-y-8" data-id="element-2071">
            {/* Warning */}
            <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-4 flex items-start gap-3" data-id="element-2072">
              <AlertTriangle className="w-5 h-5 text-yellow-600 flex-shrink-0 mt-0.5" data-id="element-2073" />
              <div className="text-sm text-yellow-800" data-id="element-2074">
                <strong data-id="element-2075">تحذير أمني:</strong> لا تشارك Client Secret مع أي شخص.
                احتفظ به في مكان آمن.
              </div>
            </div>

            {/* Steps */}
            <div className="space-y-6" data-id="element-2076">
              <div className="flex gap-4" data-id="element-2077">
                <div className="flex-shrink-0 w-8 h-8 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center font-bold" data-id="element-2078">
                  1
                </div>
                <div className="flex-1" data-id="element-2079">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-2080">
                    افتح Google Cloud Console
                  </h3>
                  <p className="text-gray-600 mb-3" data-id="element-2081">
                    انتقل إلى{' '}
                    <a href="https://console.cloud.google.com" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline inline-flex items-center gap-1" data-id="element-2082">
                      Google Cloud Console
                      <ExternalLink size={14} data-id="element-2083" />
                    </a>
                  </p>
                  <div className="bg-gray-100 rounded-lg p-4 text-center text-gray-500" data-id="element-2084">
                    [صورة توضيحية - سيتم إضافتها]
                  </div>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-2085">
                <div className="flex-shrink-0 w-8 h-8 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center font-bold" data-id="element-2086">
                  2
                </div>
                <div className="flex-1" data-id="element-2087">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-2088">
                    أنشئ مشروع جديد أو اختر مشروع موجود
                  </h3>
                  <p className="text-gray-600 mb-3" data-id="element-2089">
                    من القائمة العلوية، اضغط على اسم المشروع واختر "New Project"
                    أو اختر مشروعاً موجوداً.
                  </p>
                  <div className="bg-gray-100 rounded-lg p-4 text-center text-gray-500" data-id="element-2090">
                    [صورة توضيحية - سيتم إضافتها]
                  </div>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-2091">
                <div className="flex-shrink-0 w-8 h-8 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center font-bold" data-id="element-2092">
                  3
                </div>
                <div className="flex-1" data-id="element-2093">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-2094">
                    فعّل Google Sheets API
                  </h3>
                  <p className="text-gray-600 mb-3" data-id="element-2095">
                    اذهب إلى "APIs & Services" → "Enable APIs and Services" →
                    ابحث عن "Google Sheets API" وفعّله.
                  </p>
                  <div className="bg-gray-100 rounded-lg p-4 text-center text-gray-500" data-id="element-2096">
                    [صورة توضيحية - سيتم إضافتها]
                  </div>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-2097">
                <div className="flex-shrink-0 w-8 h-8 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center font-bold" data-id="element-2098">
                  4
                </div>
                <div className="flex-1" data-id="element-2099">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-2100">
                    أنشئ OAuth 2.0 Credentials
                  </h3>
                  <p className="text-gray-600 mb-3" data-id="element-2101">
                    اذهب إلى "Credentials" → "Create Credentials" → "OAuth
                    client ID"
                  </p>
                  <ul className="list-disc list-inside text-gray-600 space-y-1 mb-3" data-id="element-2102">
                    <li data-id="element-2103">Application type: Web application</li>
                    <li data-id="element-2104">Name: Operiens Integration</li>
                    <li data-id="element-2105">
                      Authorized redirect URIs: أضف الرابط من صفحة الإعدادات
                    </li>
                  </ul>
                  <div className="bg-gray-100 rounded-lg p-4 text-center text-gray-500" data-id="element-2106">
                    [صورة توضيحية - سيتم إضافتها]
                  </div>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-2107">
                <div className="flex-shrink-0 w-8 h-8 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center font-bold" data-id="element-2108">
                  5
                </div>
                <div className="flex-1" data-id="element-2109">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-2110">
                    انسخ Client ID و Client Secret
                  </h3>
                  <p className="text-gray-600 mb-3" data-id="element-2111">
                    بعد إنشاء الـ OAuth client، ستظهر لك نافذة تحتوي على Client
                    ID و Client Secret. انسخهما والصقهما في صفحة الإعدادات.
                  </p>
                  <div className="bg-gray-100 rounded-lg p-4 text-center text-gray-500" data-id="element-2112">
                    [صورة توضيحية - سيتم إضافتها]
                  </div>
                </div>
              </div>
            </div>

            {/* Video Tutorial */}
            <div className="border-t border-gray-100 pt-8" data-id="element-2113">
              <h3 className="font-bold text-gray-900 mb-4" data-id="element-2114">شرح بالفيديو</h3>
              <div className="bg-gray-100 rounded-lg aspect-video flex items-center justify-center text-gray-500" data-id="element-2115">
                [فيديو يوتيوب - سيتم إضافته]
              </div>
            </div>

            {/* CTA */}
            <div className="border-t border-gray-100 pt-8" data-id="element-2116">
              <Link to="/configure" data-id="element-2117">
                <Button size="lg" fullWidth data-id="element-2118">
                  رجوع إلى الإعدادات
                  <ArrowRight className="mr-2 w-5 h-5" data-id="element-2119" />
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </main>
    </div>;
}